/* tslint:disable:max-line-length */
import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('LocalStorage');

export const clearLocalStorage = actionCreator('CLEAR_LOCAL_STORAGE');
export const removeFromLocalStorage = actionCreator<IGetItemFromLocalStorageActionPayload>('REMOVE_FROM_LOCAL_STORAGE');
export const saveToLocalStorage = actionCreator<ISaveToLocalStorageActionPayload>('SAVE_TO_LOCAL_STORAGE');

// Async actions
export const getItemFromLocalStorage = actionCreator.async<IGetItemFromLocalStorageActionPayload, ILocalStorageItem>('GET_ITEM_FROM_LOCAL_STORAGE');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/localStorage.ts